import { Col, message, Row } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkButton } from 'components/atoms/button';
import { Form } from 'components/atoms/form';
import { Input } from 'components/atoms/input';
import { Modal } from 'components/atoms/modal';
import { toastService } from 'components/molecules/toast';
import { useTranslation } from 'hooks/use-translation';
import { useUser } from 'hooks/use-user';
import { useUpdateCurrentUserMutation } from 'queries';

export const ChangeNameSetting: FC = () => {
  const [form] = Form.useForm();
  const { user } = useUser();

  const successToastMsg = useTranslation(
    'settings.profile.change_name.success.message',
  );
  const successToastTitle = useTranslation(
    'settings.profile.change_name.success.title',
  );

  const changeNameTitle = useTranslation('change_name');
  const firstNameLabel = useTranslation('first_name');
  const firstNamePlaceholder = useTranslation('first_name.placeholder');
  const lastNameLabel = useTranslation('last_name');
  const lastNamePlaceholder = useTranslation('last_name.placeholder');
  const saveText = useTranslation('save');
  const errorMessage = useTranslation('input.required');

  const [isModalVisible, setIsModalVisible] = useState(false);

  const { mutate, isLoading } = useUpdateCurrentUserMutation();

  useEffect(() => {
    form.setFieldsValue({
      firstName: user.firstName,
      lastName: user.lastName,
    });
  }, [form, user.firstName, user.lastName]);

  const handleSubmit = async () => {
    form.submit();
  };

  const handleOnFinish = (values) => {
    mutate(values, {
      onSuccess: () => {
        toastService({
          title: successToastTitle,
          message: successToastMsg,
        }).success();

        setIsModalVisible(false);
      },
      onError: () => {
        message.error('Something went wrong');
      },
    });
  };

  return (
    <>
      <LinkButton onClick={() => setIsModalVisible(true)}>
        <FormattedMessage id="change_name" />
      </LinkButton>
      <Modal
        title={changeNameTitle}
        visible={isModalVisible}
        onOk={handleSubmit}
        onCancel={() => setIsModalVisible(false)}
        okText={saveText}
        okButtonProps={{ loading: isLoading }}
      >
        <Form form={form} layout="vertical" onFinish={handleOnFinish}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                rules={[{ required: true, message: errorMessage }]}
                name="firstName"
                label={firstNameLabel}
              >
                <Input autoFocus placeholder={firstNamePlaceholder} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="lastName" label={lastNameLabel}>
                <Input placeholder={lastNamePlaceholder} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
